import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import RespondentMatchingTargetJob from './RespondentMatchingTargetJob';
import { useContext } from 'react';
import { AccountContext } from '../../../../components/AccountContext';
import useSubscriptionExpiredRestrictions from '../../../../hooks/useSubscriptionExpiredRestrictions';

const RespondentTargetJobDisplay = ({ respondent, assessments, availableTranslations, toggleEdit }) => {
  const currentAccount = useContext(AccountContext);
  const { subscriptionIsExpired } = useSubscriptionExpiredRestrictions();

  return (
    <Panel
      header={
        <div className="p-grid p-nogutter">
          <div className="p-col">
            <FormattedMessage id="attrs.targetJob" defaultMessage="Target Job Profile" />
          </div>
          {!respondent.anonymizedOn && (
            <div className="p-col-2 align-right">
              <Button
                icon="fa fa-pencil"
                type="button"
                className="p-button-secondary"
                disabled={subscriptionIsExpired}
                onClick={() => toggleEdit('targetJob')}
              />
            </div>
          )}
        </div>
      }
    >
      <div className="panel-no-background">
        <div className="panel-body">
          {respondent.targetJob ? (
            <RespondentMatchingTargetJob
              respondent={respondent}
              assessments={assessments}
              currentAccount={currentAccount}
              availableTranslations={availableTranslations}
            />
          ) : (
            <div className="small text-center">
              <p>
                <FormattedMessage
                  id="attrs.targetJob.empty"
                  defaultMessage="Please define a Target Job in order to view the Job Match reports"
                />
              </p>
            </div>
          )}
        </div>
      </div>
    </Panel>
  );
};

RespondentTargetJobDisplay.propTypes = {
  respondent: PropTypes.objectOf(PropTypes.any).isRequired,
  assessments: PropTypes.arrayOf(PropTypes.any).isRequired,
  availableTranslations: PropTypes.arrayOf(PropTypes.any).isRequired,
  toggleEdit: PropTypes.func.isRequired,
};

export default RespondentTargetJobDisplay;
